import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import AppLayout from "@/components/AppLayout";
import Login from "@/pages/Login";
import ResetPassword from "@/pages/ResetPassword";
import Activate from "@/pages/Activate";
import PortalHome, { PortalEngagement } from "@/pages/Portal";
import { PortalInfoList, PortalInfoForm } from "@/pages/PortalInfo";
import ServiceChargeInbox from "@/pages/ServiceChargeInbox";
import CompletionSummary from "@/pages/CompletionSummary";
import ActivityLog from "@/pages/ActivityLog";
import EngagementList from "@/pages/EngagementList";
import Dashboard from "@/pages/Dashboard";
import EngagementWizard from "@/pages/EngagementWizard";
import EngagementDetail, { EngagementOverview } from "@/pages/EngagementDetail";
import QueriesOverview from "@/pages/QueriesOverview";
import WorkingPaperEditor from "@/pages/WorkingPaperEditor";
import TrialBalanceImport, { LeadSheets } from "@/pages/TrialBalance";
import Accounts from "@/pages/Accounts";
import AccountsPrint from "@/pages/AccountsPrint";
import WorkingPaperPrint from "@/pages/WorkingPaperPrint";
import PublicAccounts from "@/pages/PublicAccounts";
import Templates from "@/pages/Templates";
import Settings from "@/pages/Settings";
import ReportTemplateEditor from "@/pages/ReportTemplateEditor";
import Help from "@/pages/Help";
import Quote from "@/pages/Quote";
import { QuoteAccept } from "@/pages/Quote";
import Quotes from "@/pages/Quotes";
import Register from "@/pages/Register";
import MyQuotes from "@/pages/MyQuotes";

function App() {
    return (
        <AuthProvider>
            <BrowserRouter>
                <Toaster position="bottom-right" richColors closeButton />
                <Routes>
                    <Route path="/login" element={<Login />} />
                    <Route path="/reset-password" element={<ResetPassword />} />
                    <Route path="/activate" element={<Activate />} />
                    <Route path="/shared/accounts/:token" element={<PublicAccounts />} />
                    <Route path="/quote" element={<Quote />} />
                    <Route path="/quote/accept/:token" element={<QuoteAccept />} />
                    <Route path="/register" element={<Register />} />
                    <Route path="/my-quotes" element={<ProtectedRoute roles={["Prospect"]} redirect="/login"><MyQuotes /></ProtectedRoute>} />
                    <Route path="/portal" element={<ProtectedRoute roles={["Client"]} redirect="/"><PortalHome /></ProtectedRoute>} />
                    <Route path="/portal/info" element={<ProtectedRoute roles={["Client"]} redirect="/"><PortalInfoList /></ProtectedRoute>} />
                    <Route path="/portal/info/:id" element={<ProtectedRoute roles={["Client"]} redirect="/"><PortalInfoForm /></ProtectedRoute>} />
                    <Route path="/portal/:engagementId" element={<ProtectedRoute roles={["Client"]} redirect="/"><PortalEngagement /></ProtectedRoute>} />
                    <Route path="/engagements/:engagementId/accounts/print" element={<ProtectedRoute roles={["Partner", "Manager", "Senior", "Junior", "External Reviewer"]} redirect="/portal"><AccountsPrint /></ProtectedRoute>} />
                    <Route path="/engagements/:engagementId/wp-print" element={<ProtectedRoute roles={["Partner", "Manager", "Senior", "Junior", "External Reviewer"]} redirect="/portal"><WorkingPaperPrint /></ProtectedRoute>} />
                    <Route element={<ProtectedRoute roles={["Partner", "Manager", "Senior", "Junior", "Admin", "External Reviewer"]} redirect="/portal"><AppLayout /></ProtectedRoute>}>
                        <Route path="/" element={<EngagementList />} />
                        <Route path="/dashboard" element={<Dashboard />} />
                        <Route path="/engagements" element={<EngagementList />} />
                        <Route path="/archived" element={<EngagementList archived={true} />} />
                        <Route path="/engagements/new" element={<EngagementWizard />} />
                        <Route path="/engagements/:engagementId" element={<EngagementDetail />}>
                            <Route index element={<EngagementOverview />} />
                            <Route path="wp/:wpId" element={<WorkingPaperEditor />} />
                            <Route path="queries" element={<QueriesOverview />} />
                            <Route path="trial-balance" element={<TrialBalanceImport />} />
                            <Route path="accounts" element={<Accounts />} />
                            <Route path="lead-sheets" element={<LeadSheets />} />
                            <Route path="completion" element={<CompletionSummary />} />
                            <Route path="activity" element={<ActivityLog />} />
                        </Route>
                        <Route path="/templates" element={<Templates />} />
                        <Route path="/service-charge-info" element={<ServiceChargeInbox />} />
                        <Route path="/quotes" element={<Quotes />} />
                        <Route path="/help" element={<Help />} />
                        <Route path="/settings" element={<Settings />} />
                        <Route path="/report-templates/:key" element={<ReportTemplateEditor />} />
                    </Route>
                </Routes>
            </BrowserRouter>
        </AuthProvider>
    );
}

export default App;
